export default ('removeStyle', (string) => { return string.replace(/(style=".+?")/gm,'') });